<div class="bg-white rounded shadow p-1">

       
    <div class="col-md-12 row m-0 p-0">
      <div class="col-md">
        <div class="title-header" *ngIf="!isUpdate"><h5 class="m-0 p-0">Modify Hoardings</h5></div>
        <div class="title-header" *ngIf="isUpdate"><h5 class="m-0 p-0">Update Hoardings</h5></div>
      </div>
      <div class="col-md p-2">
        <div class="d-flex justify-content-end detail-buttons p-0" *ngIf="isShowBtn">
          <button type="button"  class="btn btn-outline-secondary mr-2" *ngIf="isDiscontinue" (click)="discontinue()">Discontinue</button>
          <button type="button" *ngIf="!isUpdate" class="btn btn-danger mr-2" (click)="open(mymodal)">Modify</button>
          <button type="button" *ngIf="isUpdate" class="btn btn-danger mr-2" (click)="open(mymodal)">Update</button>
        </div>
      </div>           
  </div>


   <div class="p-2">
      <div class="table-responsive p-1">
        <table class="table box-table table-borderless m-0 p-0" matSort (matSortChange)="sortData($event)" matSortActive="name" matSortDirection="asc" matSortDisableClear>
            <thead class="">
                <tr class="justify-content-center">
                        <!-- <th class="text-center"><p class="m-0">S.No</p></th> -->
                        <th class="text-center">
                          <p class="m-0 ">Select &nbsp;&nbsp;<input type="checkbox" [checked]="isAllChecked" class="m-0" (click)="CheckAllOptions()">
                        </p></th>

                        <th class="text-center" mat-sort-header = "regionName"><p class="m-0">State</p></th>
                        <th class="text-center" mat-sort-header = "showroomName"><p class="m-0">Showroom</p></th>
                        <th class="text-center" mat-sort-header = "address"><p class="m-0">address</p></th>
                        <th class="text-center" mat-sort-header = "assetTypeName"><p class="m-0">Asset Type</p></th>
                        <th class="text-center" mat-sort-header = "creativeName"><p class="m-0">Creative</p></th>
                        <th class="text-center" mat-sort-header = "vendorName"><p class="m-0">Vendor</p></th>
                        <th class=""><p class="m-0">Particulars</p></th>
                        <th class="" mat-sort-header = "cost"><p class="m-0">Cost</p></th>
                        <th class="text-center" mat-sort-header = "name"><p class="m-0">Name</p></th>
                        <th class="text-center"><p class="m-0">Size</p></th>
                        <th class="text-center"><p class="m-0">Sq. Ft</p></th>
                        <th class="text-center"><p class="m-0">Installation Date</p></th>
                        <th class="text-center"><p class="m-0">Expiry Date</p></th>
                        <th class="text-center"><p class="m-0">Modified Date</p></th>
                        <th class="text-center"><p class="m-0">Created Date</p></th>
                        <!-- <th class="text-center"><p class="m-0">Image</p></th> -->
                </tr>
              
              </thead>

              <tbody class="">
                  <tr class="" *ngFor="let data of filtered_Hoarding_Lists| filter:searchTerm | slice: (page-1) * pageSize : page * pageSize;let i=index">
                      <!-- <td class="text-center"><p class="m-0 p-0">{{i+1}}</p></td> -->
                      <td class="text-center">
                          <input type="checkbox" [checked]="data.isUpdateModify" (change)="settoUdpateModify(data.id)">
                      </td>

                      <td class="text-center"><p class="m-0 p-0">{{data.regionName}}</p></td>
                      <td class="text-center">
                          <p class="m-0">{{data.showroomName}}</p>
                      </td>
                      <td class="text-center"><p class="m-0">{{data.address}}</p></td>
                      <td class="text-center"><p class="m-0">{{data.assetTypeName}}</p></td>
                      <td class="text-center"><p class="m-0">{{data.creativeName}}</p></td>
                      <td class="text-center"><p class="m-0">{{data.vendorName}}</p></td>
                      <td class=""><p class="m-0">{{data.particulars}}</p></td>
                      <td class=""><p class="m-0">{{data.cost| currency:'INR'}}</p></td>
                      <td class="text-center"><p class="m-0">{{data.name}}</p></td>
                      <td class="text-center">
                          W {{splitNumber(data.size_w)}} x H{{splitNumber(data.size_h)}}
                      </td>
                      <td class="text-center">
                        {{splitNumber(data.size_w*data.size_h)}}
                      </td>
                      <td class="text-center"><p class="m-0 p-0">{{data.install_date}}</p></td>
                      <td class="text-center"><p class="m-0 p-0">{{data.expiry_date}}</p></td>
                      <td class="text-center"><p class="m-0 p-0">{{data.lastChanged}}</p></td>
                      <td class="text-center"><p class="m-0 p-0">{{data.firstChanged}}</p></td>

                      <!-- <td class="text-center">
                      </td> -->
                  </tr>
              </tbody> 
          </table>
          <div class="text-center p-5" *ngIf="filtered_Hoarding_Lists && filtered_Hoarding_Lists.length === 0" >
            <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
            </svg>
            <p class="m-0 no-record"> No Record Found </p>
        </div>
      </div>

      </div>
      <div class="mt-3" >
        <ngb-pagination  [(page)]="page"  [maxSize]="5"
        [pageSize]="pageSize"  *ngIf="filtered_Hoarding_Lists && filtered_Hoarding_Lists.length > 10"
        [collectionSize]="filtered_Hoarding_Lists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success  sl-pagination"></ngb-pagination>
    </div>
</div>



<ng-template #mymodal let-modal>
  <div class="title-header" *ngIf="!is_Update"><h5 class="m-0 p-0">Modify Hoardings</h5></div>
  <div class="title-header" *ngIf="is_Update"><h5 class="m-0 p-0">Update Hoardings</h5></div>

  <div class="modal-body w-100 m-0 p-0 ">
    
    <div [formGroup]="form" class="form-horizontal" >
      
      <div class="row m-0 p-0">
          <div class="col-md-6 m-0 p-0">


              <div class="row m-0 p-2">
                  <div class="input-group col-md-12 m-0 p-0">
                      <div class="input-group-prepend">
                        <div class="input-group-text">Hoarding Name</div>
                      </div>
                      <input (keypress)="omit_special_char($event)" type="text" class="form-control"  formControlName="name" placeholder="" required>
                  </div>
              </div> 
              <div class="row m-0 p-2">
                <div class="input-group col-md-12 m-0 p-0">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Area</div>
                    </div>
                    <input (keypress)="omit_special_char($event)" type="text" class="form-control"  formControlName="address" placeholder="" required>
                </div>
              </div> 

              <div class="row m-0 p-2">
                <div class="input-group col-md-12 m-0 p-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Particulars</div>
                  </div>
                  <input type="text" class="form-control"  formControlName="particulars" placeholder="" required>
                </div>
              </div> 
              <div class="row m-0 p-0">
                <div class="input-group col-md-12 m-0 p-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Asset Type</div>
                    </div>
                    <select class="custom-select round"  formControlName="asset_type_id"  required>
                      <option value="">Select Asset</option>
                      <option *ngFor="let data of AssetsDataLists" [ngValue]="data.id">{{data.name}}</option>
                    </select>
                </div>
              </div>
                <div class="row m-0 p-0">
              
                <div class="input-group col-md-12 m-0 p-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Creative</div>     
                  </div>   
                   <select class="custom-select round"  formControlName="creative_id"  required>
                    <option value="">Select Creative</option>
                    <option *ngFor="let data of CreativeDataLists" [ngValue]="data.id">{{data.name}}</option>
                  </select>
                 </div>
              </div>
              <div class="row m-0 p-0">
                <div class="input-group col-md-12 m-0 p-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Vendor</div>
                    </div>
                    <select class="custom-select round" formControlName="vendor_id" required>
                      <option value="">Select Vendor</option>
                      <option *ngFor="let data of VendorDataLists" [ngValue]="data.id">{{data.name}}</option>
                    </select>
                </div>
              </div>
              
              <div class="row m-0 p-0">
                <div class="input-group col-md-6 m-0 p-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Width</div>
                    </div>
                    <input type="number" class="form-control"  formControlName="size_w" placeholder="" (change)="onWidthChange()" required>
                </div>
                <div class="input-group col-md-6 m-0 p-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Height</div>
                  </div>
                  <input type="number" class="form-control"  formControlName="size_h" placeholder="" (change)="onHeightChange()" required>
                 </div>
              </div>

                 
              <div class="row m-0 p-0">
                <div class="input-group col-md-6 m-0 p-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Sq. Feet</div>
                    </div>
                    <input type="number" class="form-control"  formControlName="square_feet" placeholder="" required disabled>
                </div>
                <div class="input-group col-md-6 m-0 p-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Cost (&#8377;)</div>
                  </div>
                  <input type="number" class="form-control"  formControlName="cost" placeholder="" required>
                 </div>
              </div>
              <div class="row m-0 p-2">
                <div class="input-group col-md-12 m-0 p-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Address</div>
                  </div>
                  <input type="text" class="form-control"  formControlName="address" placeholder="" required>
                </div>
              </div> 
          </div>  
          <div class="col-md-6 m-0 p-0">
            <div class="row m-0 p-2">
              <div class="input-group col-md-12 m-0 p-0">
                <label class="label-header">Hoarding Image:</label>
                <div class="uploader">
    
                  <input id="file-upload" type="file" name="fileUpload" accept="image/*" (change)="onFileChange($event)"/>
    
                  <label for="file-upload" id="file-drag">
                    <img [src]="imageSrc" *ngIf="imageSrc"  id="file-image">
                    <div id="start" *ngIf="!imageSrc">
                      <i class="fa fa-download" aria-hidden="true"></i>
                      <div class="label-header">Select a Picture</div>
                    </div>
                  </label>
                </div>

              </div>
            </div>
            
            <div class="row m-0 p-0">
              <div class="input-group col-md-12 m-0 p-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Installation Date</div>
                  </div>
                  <input class="form-control" matInput [max]="form.controls['expiry_date'].value" formControlName="install_date" (dateChange)="startDateClicked($event)" 
                            [matDatepicker]="picker1" placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="picker1" #startDateToggle></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>

              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="input-group col-md-12 m-0 p-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Expiry Date</div>
                </div>
                <input class="form-control" matInput [min]="form.controls['install_date'].value" formControlName="expiry_date" (dateChange)="endDateClicked($event)" [matDatepicker]="picker2"
                      placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="picker2" #endDateToggle></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </div>
            </div>

            <div class="col-lg-12 d-flex justify-content-center detail-buttons p-4">
              <button type="button" class="btn btn-danger mr-2" (click)="onHoardingSubmit()">{{isUpdate? 'Update' : 'Modify'}}</button>
              <button type="button" class="btn btn-dark" (click)="modal.dismiss('Cross click')">Cancel</button>
            </div>
            
          </div>
      </div>  
      
    </div>
  </div>
</ng-template>